import { createActions } from "../../helpers/utils/createActions";
import { SECTION } from "./actionTypes";

export const getListaSection = createActions(SECTION.GET_LIST);
export const getSection = createActions(SECTION.GET_SECTION);
export const saveSection = createActions(SECTION.SAVE_SECTION);
export const duplicateSection = createActions(SECTION.DUPLICATE_SECTION);

export const getSectionHistory = createActions(SECTION.GET_SECTION_HISTORY);
export const getSectionHistoryList = createActions(SECTION.GET_SECTION_HISTORY_LIST);
export const getSectionAll = createActions(SECTION.GET_SECTION_ALL);

export const getSectionProducts = createActions(SECTION.GET_SECTION_PRODUCTS);
export const getSectionSnippets = createActions(SECTION.GET_SECTION_SNIPPETS);

export const getSectionPreview = createActions(SECTION.GET_SECTION_PREVIEW);

export const postSectionDownloadList = createActions(SECTION.POST_SECTION_DOWNLOAD_LIST);

export const loadEmptySection = () => ({ type: SECTION.LOAD_EMPTY });
export const cleanMessageSection = () => ({ type: SECTION.CLEAN_MESSAGE });
export const disableLoadingSection = () => ({ type: SECTION.DISABLE_LOADING_SECTION })
export const cleanIdSectionDuplicate = () => ({ type: SECTION.CLEAN_ID_SECTION_DUPLICATE });
export const changePageSizeSection = (payload) => ({ type: SECTION.CHANGE_PAGE_SIZE_SECTION, payload });
